var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "sap-payment-delete-modal",
            "cancel-title": "Abbrechen",
            "ok-title": "Alle Zahlungen löschen",
            size: "xl",
            title: "Zahlungen löschen",
            visible: _vm.isModalOpen,
          },
          on: {
            hidden: function ($event) {
              _vm.reset()
              _vm.$emit("close")
            },
            ok: _vm.deletePayments,
            show: _vm.loadPayments,
          },
        },
        [
          _vm.isLoading
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-center pt-1" },
                [_c("csp-loading-indicator")],
                1
              )
            : _c(
                "div",
                [
                  _vm.payments.length > 0
                    ? _c("div", [
                        _c("h2", { staticClass: "mb-4" }, [
                          _vm._v(
                            "\n                    Zahlungen, die aus der selben SAP Zahlung erstellt wurden\n                "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.payments, function (payment) {
                    return _c(
                      "b-card",
                      { key: payment.id, staticClass: "info-card" },
                      [
                        _c(
                          "b-row",
                          _vm._l(
                            _vm.filteredPaymentAttributes(payment),
                            function (value, key) {
                              return _c(
                                "b-col",
                                { key: key, attrs: { cols: "4" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "info-card-element" },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.labels[key] || key) +
                                            "\n                            "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "value" }, [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.formatters[key]
                                                ? _vm.formatters[key](value)
                                                : value
                                            ) +
                                            "\n                            "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                        _vm._v(" "),
                        _c("hr"),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }